
import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import styles from './header-web.module.scss';
import { BaseHeaderWeb } from './components/BaseHeaderWeb';
import { useBreadcrumbs, useHeaderSelect } from './hooks';
import { getHeaderConfig } from './utils/headerConfig';

import './header-web.module.scss';

const ENV = (import.meta as any).env;
const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

const {
  Header__Web,
  Navigation,
} = styles;

function SimpleNavigation(props: any) {
  const { t } = useTranslation();
  
  return (
    <div className={Navigation}>
      <strong>{t(`widgets.header.${props.label}`)}</strong>
    </div>
  );
}

function HeaderWeb(props: any) {
  const location = useLocation();
  const pathSegment = location.pathname.split('/')[1];
  const config = getHeaderConfig(pathSegment, props);
  
  const breadcrumbs = useBreadcrumbs(config.type);
  const {
    selectOptions,
    currentSelectValue,
    onSelectChange,
    isSelectOpen,
    setSelectOpen,
    triggerSelectOpen
  } = useHeaderSelect(config.type);

  // Handle default case - if no specific config, show simple navigation
  if (config.type === 'default') {
    return (
      <div className={`${Header__Web} ${isSafari ? 'Header__Web__Safari' : ''}`}>
        <SimpleNavigation {...props} />
      </div>
    );
  }

  return (
    <div className={`${Header__Web} ${isSafari ? 'Header__Web__Safari' : ''}`}>
      <BaseHeaderWeb
        breadcrumbs={breadcrumbs}
        showCalendar={config.showCalendar}
        showSearch={config.showSearch}
        showProfile={config.showProfile}
        showDownload={config.showDownload}
        selectOptions={selectOptions}
        currentSelectValue={currentSelectValue}
        onSelectChange={onSelectChange}
        isSelectOpen={isSelectOpen}
        setSelectOpen={setSelectOpen}
        triggerSelectOpen={triggerSelectOpen}
      />
    </div>
  );
}

export default React.memo(HeaderWeb);
